import React from 'react'
import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import AdxStatusBar from 'components/reusable/statusBar/AdxStatusBar'
import { CardMedia } from '@mui/material'

const CandidateListDrawerCard = ({
  id,
  data,
  changeApplicantDetail,
  status,
  profilePicture,
  applicantName,
  createdAt,
  unlocked,
  inCart,
  job_status,
  isChoosenName,
  isChoosenId,
  profile_type,
}) => {
  //change date format
  const date = new Date(createdAt)
  const formattedDate = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })

  const getProfileMessage = (profileType, date) => {
    if (
      status === 'self apply' ||
      status === 'self apply through job recommender' ||
      status === 'self apply & matched' ||
      status === 'self apply through job recommender & matched'
    ) {
      switch (profileType) {
        case 'jobseeker':
          return `Applied via adnexio on ${date}`
        case 'job_board':
          return `Applied via Job board on ${date}`
        default:
          return `Applied via External on ${date}`
      }
    } else {
      switch (profileType) {
        case 'jobseeker':
          return `Matched via adnexio`
        case 'job_board':
          return `Matched via Job board`
        default:
          return `Matched via External`
      }
    }
  }
  const message = getProfileMessage(profile_type, formattedDate)

  return (
    <Box
      display="flex"
      alignItems="center"
      columnGap={2}
      padding={2}
      sx={{
        borderBottom: '1px solid',
        borderBottomColor: 'gray-line.main',
        overflow: 'hidden',
        cursor: 'pointer',
        backgroundColor: isChoosenId === id ? 'default-background.main' : null,
        '&:hover': {
          backgroundColor: 'default-background.main',
        },
      }}
      onClick={() => {
        changeApplicantDetail(data)
        // setClickedName(data?.relations?.candidateable?.relations?.applicant?.name)
      }}
    >
      <Box display="flex" alignItems="center" columnGap={2}>
        {/* if user is not unlocked, profile picture will show locked */}
        {!unlocked ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width={45}
            height={45}
            bgcolor="gray-background.main"
            color="white.main"
            borderRadius="50%"
          >
            <Icon
              sx={{
                color: 'light-gray-text.main',
              }}
            >
              locked
              {/* if person if from external source, the icon is person outline */}
              {/* person_outline */}
            </Icon>
          </Box>
        ) : (
          // if user is unlocked and picture is  uploaded
          <Box>
            {profilePicture !== null ? (
              <Box>
                <CardMedia
                  component="img"
                  sx={{
                    height: 45,
                    width: 45,
                    objectFit: 'cover',
                    borderRadius: '50%',
                    // mb={2}
                  }}
                  src={profilePicture}
                />
              </Box>
            ) : status === 'matched by candidate recommender' ? (
              // if user is unlocked and picture is NOT uploaded
              <Box
                width={45}
                height={45}
                borderRadius="50%"
                bgcolor="gray-background.main"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Icon
                  sx={{
                    color: 'light-gray-text.main',
                  }}
                >
                  person_outline_outlined
                </Icon>
              </Box>
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width={45}
                height={45}
                bgcolor="alternate.main"
                color="white.main"
                borderRadius="50%"
                sx={{
                  textTransform: 'capitalize',
                }}
              >
                {applicantName?.charAt(0)}
              </Box>
            )}
          </Box>
        )}
      </Box>

      <Box
        display="flex"
        flexDirection={{ xs: 'column', lg: 'row' }}
        rowGap={2}
        justifyContent="space-between"
      >
        <Box>
          <Box display="flex" columnGap={1} alignItems="start" flexWrap="wrap">
            <Typography
              variant="body1"
              color="dark-text.main"
              marginBottom={0.5}
              sx={{
                textTransform: 'capitalize',
                // display: "-webkit-box",
                // WebkitLineClamp: 2,
                // WebkitBoxOrient: "vertical",
                maxWidth: 250,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {applicantName}
            </Typography>

            {/* in cart icon will be displayed if user is put in cart ( only for unpaid user) */}
            {inCart && (
              <AdxStatusBar
                sx={{ py: 0 }}
                status={{
                  text: 'In cart',
                  color: 'light-gray-text.main',
                  bgColor: 'gray-background.main',
                }}
              />
            )}
          </Box>
          <Box display="flex" alignItems="center" columnGap={3}>
            <Box display="flex" alignItems="center" columnGap={1}>
              <Box display="flex" alignItems="center" columnGap={1}>
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor:
                      profile_type === 'jobseeker'
                        ? 'alternate.main'
                        : profile_type === 'job_board'
                        ? 'information.main'
                        : 'yellow-01.main',
                  }}
                ></Box>
                <Typography variant="body2" color="light-gray-text.main">
                  {message}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default CandidateListDrawerCard
